import { getTransactionHistory } from '@/lib/transaction-history';

export const getTransactionHistoryData = (pathname: string, params: string) => {
    const searchParams = params.includes('type=mobile') ? params : `${params}&type=mobile`;

    return getTransactionHistory({ pathname, search: searchParams });
};
